import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCurrentStyles } from "@Broker/js/custom/utils";
import { updateColours } from "@Shared/@Utils/utils";
import Colorpicker from "@Shared/components/inputs/colorpicker";
import { SET_STYLES } from "@Broker/@Modules/main/store/account/account-mutations";
import { LOAD_STYLES } from "@Broker/@Modules/main/store/account/account-actions";
import { UPDATE_PERSONAL_STYLES, UPDATE_BROKERAGE_STYLES, UPDATE_NAV_LOGO } from "../../store/settings-actions";
import { mapState, mapMutations, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { showToast } from "@Shared/@Utils/constants";
import { isValidColor } from "@Shared/@Utils/validation-rules";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Theme",
  components: {
    Colorpicker
  },
  mixins: [validationMixin],
  props: {
    settingsType: {
      type: String,
      required: true
    },
    saving: {
      type: Boolean,
      required: true
    },
    currentThemeObject: {
      type: Object,
      default: () => ({})
    }
  },
  validations: {
    currentPrimary: {
      required,
      isValidColor
    },
    currentSecondary: {
      required,
      isValidColor
    },
    currentTheme: {
      primary: {
        required,
        isValidColor
      },
      secondary: {
        required,
        isValidColor
      }
    }
  },
  data() {
    return {
      formChanged: false,
      themes: [{
        label: "Strawberry Fields",
        value: "strawberry",
        primary: "#AD3948",
        secondary: "#740E28"
      }, {
        label: "Night Sky",
        value: "night",
        primary: "#3B3C60",
        secondary: "#BD5500"
      }, {
        label: "Evergreen",
        value: "evergreen",
        primary: "#158463",
        secondary: "#11767E"
      }, {
        label: "Valencia",
        value: "valencia",
        primary: "#D1420A",
        secondary: "#BD5500"
      }, {
        label: "Wine County",
        value: "wine",
        primary: "#c137a2",
        secondary: "#694ed6"
      }, {
        label: "Azure",
        value: "azure",
        primary: "#006198",
        secondary: "#004D9C"
      }],
      currentTheme: {
        primary: "",
        secondary: ""
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("SettingsStore", ["brokerageData", "overrides", "isOnThemePreviewMode"])), mapState("AccountStore", ["accountDetails", "styles"])), {}, {
    isBrokerageSettings() {
      return this.settingsType === "brokerage-settings";
    },
    isPersonalSettings() {
      return this.settingsType === "personal-settings";
    },
    customizeMessageBySettingsType() {
      return this.isBrokerageSettings ? this.$t("settings.themeTab.customizeTextBrokerage") : this.$t("settings.themeTab.customizeTextPersonal");
    },
    isValid() {
      return !this.$v.$invalid;
    },
    currentPrimary() {
      return this.currentThemeObject.primary || "";
    },
    currentSecondary() {
      return this.currentThemeObject.secondary || "";
    },
    currentThemeString() {
      var _this$themes$find$lab, _this$themes$find, _context;
      return (_this$themes$find$lab = (_this$themes$find = _findInstanceProperty(_context = this.themes).call(_context, theme => this.currentTheme.primary === theme.primary && this.currentTheme.secondary === theme.secondary)) == null ? void 0 : _this$themes$find["label"]) != null ? _this$themes$find$lab : "own";
    },
    currentThemeIsCustom() {
      return !this.currentTheme.label;
    }
  }),
  watch: {
    saving(value) {
      if (!value) return;
      this.saveTheme();
    },
    isOnThemePreviewMode(value) {
      if (!value) {
        var _this$themes$find$val, _this$themes$find2, _context2;
        const currentThemeName = (_this$themes$find$val = (_this$themes$find2 = _findInstanceProperty(_context2 = this.themes).call(_context2, theme => theme.primary === this.currentPrimary && theme.secondary === this.currentSecondary)) == null ? void 0 : _this$themes$find2.value) != null ? _this$themes$find$val : "own";
        $(`[name='theme-radio'][value='${currentThemeName}']`).click();
      }
    },
    currentThemeObject: {
      handler(value) {
        var _context3;
        const {
          primary = "",
          secondary = ""
        } = value;
        this.currentTheme = _findInstanceProperty(_context3 = this.themes).call(_context3, t => t.primary === primary && t.secondary === secondary) || value;
      },
      immediate: true
    },
    currentTheme: {
      handler(value) {
        // Only update the colours if they have valid values
        if (this.isValid && this.currentThemeIsCustom) {
          updateColours(value.primary, value.secondary);
        }
        this.$emit("allow-save", this.isValid);
      },
      deep: true
    }
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapMutations("AccountStore", [SET_STYLES])), mapActions("AccountStore", [LOAD_STYLES])), mapActions("SettingsStore", [UPDATE_BROKERAGE_STYLES, UPDATE_PERSONAL_STYLES, UPDATE_NAV_LOGO])), {}, {
    isThemeChecked(theme) {
      if (theme === "own") {
        return this.currentThemeIsCustom;
      } else {
        var _context4;
        const selectedTheme = _findInstanceProperty(_context4 = this.themes).call(_context4, t => t.value === theme) || this.currentThemeObject;
        return selectedTheme.primary === this.currentPrimary && selectedTheme.secondary === this.currentSecondary;
      }
    },
    getThemeImg(theme) {
      const images = require.context("@Broker/@Assets/img", true, /\.png/);
      return images(`./${theme.value}.png`);
    },
    handleChangeTheme(event) {
      var _event$target$value, _event$target, _context5;
      this.$emit("allow-save", this.isValid);
      this.$emit("form-change", true);
      this.formChanged = true;
      const selectedColorValue = (_event$target$value = (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : event;
      this.currentTheme = _findInstanceProperty(_context5 = this.themes).call(_context5, t => t.value === selectedColorValue) || this.currentThemeObject;
      updateColours(this.currentTheme.primary, this.currentTheme.secondary);
    },
    async savePersonalTheme() {
      const file = getCurrentStyles();
      const override = this.overrides.overrideStyle;
      await this.UPDATE_PERSONAL_STYLES({
        file
      });
      if (override === false) this.LOAD_STYLES();
      this.$emit("finish-saving", true);
      this.$emit("form-change", false);
      this.formChanged = false;
    },
    async saveBrokerageTheme() {
      const file = getCurrentStyles();
      const override = this.overrides.overrideStyle;
      await this.UPDATE_BROKERAGE_STYLES({
        file
      });
      if (override) this.LOAD_STYLES();
    },
    async saveTheme() {
      try {
        if (this.settingsType === "brokerage-settings") {
          await this.saveBrokerageTheme();
        } else {
          await this.savePersonalTheme();
          return showToast("success", "themeUpdated");
        }
        if (!this.overrides.overrideLogo) {
          this.UPDATE_NAV_LOGO({
            domain: this.accountDetails.accountSubdomain
          });
        }
        showToast("success", `brokerageThemeUpdated`);
        this.$emit("finish-saving", true);
        this.$emit("form-change", false);
        this.formChanged = false;
      } catch (e) {
        this.$emit("finish-saving", false);
      }
    }
  })
});